import { render, staticRenderFns } from "./CreditDetailsContainer.vue?vue&type=template&id=3516795e&scoped=true"
import script from "./CreditDetailsContainer.vue?vue&type=script&lang=js"
export * from "./CreditDetailsContainer.vue?vue&type=script&lang=js"
import style0 from "./CreditDetailsContainer.vue?vue&type=style&index=0&id=3516795e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3516795e",
  null
  
)

export default component.exports